<template>
  <div class="ion-page">
    <ion-header translucent>
      <ion-toolbar>
        <ion-title>TonyTalks</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content fullscreen class="ion-padding">
      <items></items>
    </ion-content>
  </div>
</template>

<script>
import Items from "../components/Items";
import * as firebase from "firebase/app";

export default {
  name: "home",
  components: {
    Items
  },
  data() {
    return {
      info: null,
      i: 0,
      photo: ""
    };
  },
  computed: {},
  created() {},
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    }
  }
};
</script>
